import React from 'react';

import PropTypes from 'prop-types';

import Helmet from 'wanderu-component-helmet';
import { localize } from 'wanderu-i18n';

import carrierContactConfig from '../../../../config/carriercontact.locale';

function CarrierContactMeta(props) {
    const {
        t,
        ...otherProps
    } = props;

    const description = t('metaPageDescription');
    const title = t('metaPageTitle');

    return (
        <Helmet
            {...otherProps}
            description={description}
            supportedLocales={carrierContactConfig.supportedLocales}
            title={title}
        />
    );
}

CarrierContactMeta.propTypes = {
    structuredData: PropTypes.arrayOf(PropTypes.object),
};
CarrierContactMeta.defaultProps = {
    structuredData: [],
};

export {
    CarrierContactMeta,
};

export default localize(CarrierContactMeta, ['i18nMoney', 't'], carrierContactConfig.namespace);
